import { render } from "./deals-dashboard-table.vue?vue&type=template&id=19a8559e&scoped=true"
import script from "./deals-dashboard-table.vue?vue&type=script&lang=js"
export * from "./deals-dashboard-table.vue?vue&type=script&lang=js"

import "./deals-dashboard-table.vue?vue&type=style&index=0&id=19a8559e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a8559e"]])

export default __exports__